import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { spacing16 } from "@churchofjesuschrist/eden-style-constants";
const Container = styled.div.withConfig({
  componentId: "sc-zwfeft-0"
})(["display:flex;width:100%;justify-content:space-between;align-items:center;padding:", ";"], spacing16);

const Head = _ref => {
  let {
    start,
    end
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, null, start ? start : /*#__PURE__*/React.createElement("div", null), end ? end : /*#__PURE__*/React.createElement("div", null));
};

Head.propTypes = {
  /** First section of header */
  start: PropTypes.node,

  /** second section of header */
  end: PropTypes.node
};
export default Head;